// 本地上传签章弹窗
<template>
  <el-dialog
    title="上传图片制作印章"
    :visible.sync="diaVisi"
    :width="responsiveValue"
    :before-close="handleClose"
    >
    <el-row :gutter="5" class="row-box">
      <el-col :span="7" class="pub-sty">
        <div class="first">
          <p class="m-b-10">一、上传图片</p>
          <div class="first-content">
            <template v-if="sealImgBase64">
              <div class="seal-creat flex-col-center">
                <img
                  ref="sealCreateRef"
                  :src="sealImgBase64"
                  alt=""
                >
              </div>
              <div class="option">
                <!-- 操作项 -->
                <div class="option-tool flex-around">
                  <i class="el-icon-refresh-left" @click="rotateSeal(-1)"></i>
                  <i class="el-icon-refresh-right" @click="rotateSeal(1)"></i>
                  <i class="el-icon-zoom-out" @click="scaleZoom('out')"></i>
                  <i class="el-icon-zoom-in" @click="scaleZoom('in')"></i>
                  <span class="re-upload">
                    <el-upload
                      action=""
                      accept="image/*"
                      :limit="1"
                      :before-upload="beforeSealUpload"
                      :show-file-list="false"
                    >
                      <i class="el-icon-upload2"></i>重新上传
                    </el-upload>
                  </span>
                </div>
                <div class="flex-between">
                  <span>角度</span>
                  <div style="width:70%">
                    <el-slider v-model="sealOption.scale" size="small" :min="-180" :max="180" @input="realRotation"></el-slider>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="seal-creat flex-col-center">
                <el-upload
                  action=""
                  accept="image/*"
                  :limit="1"
                  :before-upload="beforeSealUpload"
                  :show-file-list="false"
                >
                  <div>
                    <i class="el-icon-plus icon-sty"></i>
                    <p>点击上传签章图片</p>
                  </div>
                </el-upload>
              </div>
            </template>
          </div>
        </div>
      </el-col>
      <el-col :span="9" class="pub-sty second">
        <div class="second-body">
          <!-- <span class="refresh" @click="reset"><i class="el-icon-refresh"></i>重置</span> -->
          <p class="m-b-10">二、印章设置</p>
          <p class="m-b-10 m-t-distance text-color">印章名称:</p>
          <el-input
              v-model="sealAttri.signName"
              size="small"
              placeholder="请输入印章名称"
            ></el-input>
          <p class="m-b-10 m-t-distance text-color">印章颜色</p>
            <el-radio-group v-model="sealAttri.color" class="color-radio" @input="sealColorChange">
              <el-radio :label="-1">
                <div class="color-item-sty" :class="{'select-none-sty':!!(sealAttri.color == -1)}">
                  <div class="seal-dome-none">
                    <span class="none-sty"></span>
                  </div>
                </div>
              </el-radio>
              <el-radio :label="1">
                <div class="color-item-sty" :class="{'select-sty':!!(sealAttri.color == 1)}">
                  <div class="seal-dome red"></div>
                </div>
              </el-radio>
              <el-radio :label="2">
                <div class="color-item-sty" :class="{'select-sty': !!(sealAttri.color == 2)}">
                  <div class="seal-dome blue"></div>
                </div>
              </el-radio>
              <el-radio :label="3">
                <div class="color-item-sty" :class="{'select-sty':!!(sealAttri.color == 3)}">
                  <div class="seal-dome black"></div>
                </div>
              </el-radio>
            </el-radio-group>
          <div>
            <p class="m-b-10 m-t-distance text-color">
              印章规格（毫米）
              <el-tooltip class="item" effect="dark" content="印章规格最大值60毫米，最小值10毫米" placement="right">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </p>
            <div class="m-b-10" style="margin-bottom:20px">
              <span style="margin-right:20px;">宽</span>
              <el-input-number v-model="sealAttri.width" size="small" :min="10" :max=" 60" @change="changeSize"></el-input-number>
            </div>
            <div class="m-b-10">
              <span style="margin-right:20px;">高</span>
              <el-input-number v-model="sealAttri.height" size="small" :min="10" :max="60" @change="changeSize"></el-input-number>
            </div>
          </div>
          <template>
            <p class="m-b-10 m-t-distance">背景透明度&nbsp;<el-tooltip class="item" effect="dark" content="数值越大则去除印章背景效果越强" placement="right">
              <i class="el-icon-question"></i>
            </el-tooltip></p>
            <div>
              <el-slider v-model="sealAttri.range" size="small" :min="1" :max="255" @change="bgattrs"></el-slider>
            </div>
          </template>
        </div>
      </el-col>
      <el-col :span="8" class="pub-sty">
        <div class="third">
          <!-- <p class="m-b-10">三、印章效果</p> -->
          <div ref="previewRef">
            <div class="prview-img">
              <img :src="cropedImg" alt="效果" :width="userType ==1 ? `${convertWidth}px` : '117px'" :height="userType ==1 ? `${convertHeight}px` : '81px'">
            </div>
            <div v-show="userType ==1">
              <!-- <div>
                <img src="/images/advancedVersion/u16.png" alt="示例">
              </div> -->
                <p>1.请保证印章清晰、完整可见；</p>
                <p>2.印章请紧贴四周，避免过多留白。</p>
            </div>
            <el-button
            type="primary"
            :loading="loading"
            size="small"
            class="confirm-btn"
            @click="handCreatedSeal"
            >确 定</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import EntSignController from "@/assets/js/http-serve/entSignController";
import { Loading } from 'element-ui';
import {mapGetters} from "vuex"
import qs from "qs";
import {
  ApiMethods,
} from "@/assets/js/http-serve/http-methods";

export default {
  props: {
    isAddSign:{
      type:Boolean,
      default:false
    },
    userType:{
      type:Number,
      default:0
    },
		newSign: {
			type: Object,
			default: ()=>{}
		}
	},
  data () {
    // 这里存放数据
    return {
      antiShakeTimer:null,
      cropper:null, // 图片裁剪工具实例
      conver:4.5, // 转换比例 1mm = 4.5px
      loading:false,
      diaVisi:true, // 弹窗控制
      /** 印章属性 */
      sealOption:{
        scale:0,
      },
      sealAttri:{
        signName:'',
        height: this.userType == 1 ? 40 : 18,
        width:this.userType == 1 ? 40 : 26,
        color:-1, // 1 红 2 蓝 3 黑
        range: 47,
      },
      sealImgBase64:null,
      cropedImg:`${this.userType == 1 ? '/images/advancedVersion/u16.png' : '/images/chap_demo_4.jpg'}`,
      sealFileBolb:null, // 上传的文件
    };
  },
  computed: {
    ...mapGetters(['getConverScale']),
    // 计算签章毫米转化像素
    convertWidth () {
      return this.sealAttri.width * this.conver;
    },
    convertHeight () {
      return this.sealAttri.height * this.conver;
    },
    // 屏幕适配
    responsiveValue() {
      const screenWidth = window.innerWidth;
      if (screenWidth < 600) {
        // console.log('Small Screen',screenWidth);
        return '99%';
      } else if (screenWidth >= 600 && screenWidth < 900) {
        // console.log('Medium Screen',screenWidth);
        return '99%';
      } else {
        // console.log('Large Screen',screenWidth);
        return '65%';
      }
    }
  },
  watch: {
    newSign:{
      handler(val){
        const len = val && Object.keys(val).length;
        if(!!len) this.sealAttri = Object.assign(this.sealAttri,val);
        if(!!len && !!val.signUrl) {
          const _this=this;
          _this.$nextTick(()=>{
            _this.fetchImageToBase64(val.signUrl)
          })
        }
      },
      deep:true,
      immediate:true,
    },
  },
  // 方法集合
  methods: {
    /** 如果是编辑。先调用图片转base64格式文件 */
    async fetchImageToBase64(imageUrl) {
      const _this=this
      const url = qs.parse(imageUrl.split('?')[1]);
      ApiMethods.FileOperController.download_downApi(url).then(res=>{
        const blob = new Blob([res], { type: 'image/png' }); // 根据你的实际情况设置MIME类型
        // 使用 File 构造函数创建 File 对象
        const fileName = url.ts;
        const file = new File([blob], fileName, {
            type: blob.type,
            lastModified: Date.now()
        });
        _this.beforeSealUpload(file)
        // 编辑时，默认缩放到图片最小值
        setTimeout(()=>{_this.cropper && _this.cropper.zoom(-100)},300)
      })
    },
    handleClose(done){
      this.reset()
      this.$emit('signCreated');
      done();
    },
    /** 重置 */
    reset(){
      this.sealImgBase64 = null
      this.cropedImg = `${this.userType == 1 ? '/images/advancedVersion/u16.png' : '/images/chap_demo_4.jpg'}`
      this.sealFileBolb = null // 上传的文件
      this.sealAttri={
        signName:'',
        height: this.userType === 1 ? 40 : 18,
        width:this.userType === 1 ? 40 : 26,
        color:1, // 1 红 2 蓝 3 黑
        range: 47,
      }
      this.sealOption={
        scale:0,
      }
      this.cropper && this.cropper.destroy();
    },
    /** 请求后端预览签章 */
    previewSign ({imgBase64}) {
      const _this = this
      return new Promise((resolve,reject)=>{
        const {range,color} = _this.sealAttri;
        const param = {image:imgBase64,range:range.toString()};
        if(color !== -1) param.color = color.toString()
        EntSignController.uploadPreview(param).then(res => {
          // 将ArrayBuffer转换为Blob对象
          const blob = new Blob([res], { type: 'image/png' }); // 根据你的实际情况设置MIME类型
          // 创建一个指向Blob对象的URL
          const url = URL.createObjectURL(blob);
          _this.cropedImg = url
          _this.sealFileBolb=blob
          // _this.sealFileBolb=new File([blob], {type: blob.type})
          resolve(res)
          }).catch(err => {
            _this.$message(err || "网络错误请重试");
            reject(err);
          });
      })
    },
    /** 确定创建签章 */
    handCreatedSeal(){
      if(!this.sealAttri.signName) return this.$message.warning('请输入印章名称');
      this.userType === 1 ? this.entySignCreated() : this.personSignCreated()
    },
    /** 企业创建印章接口 */
    entySignCreated(){
      this.loading = true;
      const {signName,color,range,width,height,signId}=this.sealAttri
      const param = {signName,color,range,width,height,image:this.sealFileBolb}
      if(signId) param.signId = signId
      const FD = new FormData()
      for (const key in param) {
        FD.append(key, param[key]);
      }
      EntSignController.fileSealUpadte(FD)
        .then(res => {
          if(!res.success) return this.$message(res.description);
          this.$emit('signCreated',1);
          this.$message.success('签章保存成功');
        })
        .catch(err => {
          this.$confirm(err.description || "签章保存失败", "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          });
        }).finally(()=>{this.loading = false});
    },
    /** 个人类型签章创建接口 */
    personSignCreated(){
      this.loading = true;
      const {signName,color,range,width,height,signId}=this.sealAttri
      const param = {signName,color,range,width,height,image:this.sealFileBolb}
      if(signId) param.signId = signId
      const FD = new FormData()
      for (const key in param) {
        FD.append(key, param[key]);
      }
      EntSignController.perSignFileUpdate(FD)
        .then(res => {
          if(!res.success) return this.$message(res.description);
          this.$emit('signCreated',1);
          this.$message.success('签章保存成功');
        })
        .catch(err => {
          this.$confirm(err.description || "签章保存失败", "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          });
        }).finally(()=>{this.loading = false});
    },
    /**
     * changeSize 方法用于调整裁剪框的大小。
     * 当调用此方法时，如果存在裁剪器实例（this.cropper），则会获取当前画布数据（cropperCanvas），
     * 然后根据预设的裁剪框大小（cropBoxSize）计算新的裁剪框位置和尺寸，
     * 并更新裁剪器的裁剪框数据。
     * 这样可以确保新的裁剪框始终位于画布中心，并且具有指定的宽度和高度。
     */
    changeSize(){
      if(this.cropper){
        const cropperCanvas = this.cropper.getCanvasData();
        const cropBoxSize = { width: this.convertWidth, height: this.convertHeight }; // 裁剪框大小
        // console.log('cropBoxSize',cropBoxSize);
        // 设置裁剪框大小
        this.cropper.setCropBoxData({
          left: (cropperCanvas.width - cropBoxSize.width) / 2,
          top: (cropperCanvas.height - cropBoxSize.height) / 2,
          width: cropBoxSize.width,
          height: cropBoxSize.height
        });
        this.getImgView()
      }
    },
    /**
     * 根据传入的类型调整图像的缩放级别。
     * @param {string} type - 缩放类型，'in' 表示放大，'out' 表示缩小。
     * @description 该函数用于控制图像的缩放，通过调用 cropper 对象的 zoomIn 和 zoomOut 方法来实现放大和缩小效果。
     */
    scaleZoom(type){
      if(type === 'in') this.cropper && this.cropper.zoom(0.1)
      if(type === 'out') this.cropper && this.cropper.zoom(-0.1)
    },
    /** 旋转事件 */
    rotateSeal(cacl){
      cacl && cacl < 1 ? this.sealOption.scale-=1 : this.sealOption.scale += 1;
      this.cropper && this.cropper.rotateTo(this.sealOption.scale)
    },
    /** 控制旋转 */
    realRotation(rota){
      this.cropper && this.cropper.rotateTo(rota)
    },
    /** 背景透明度 */
    bgattrs(val){
      this.cropper && this.getImgView()
    },
    /** 印章颜色改变 */
    sealColorChange(color){
      this.sealAttri.color = color
      this.cropper && this.getImgView()
    },
    /**
     * 在上传印章前处理文件的方法。
     * 使用FileReader将图片文件转换为base64编码。
     * 加载完成后，更新印章图片的base64编码，并根据情况初始化或替换裁剪器中的图片。
     * @param {File} file - 需要上传的图片文件。
     * @returns {boolean} 返回false以阻止默认的上传行为。
     */
    beforeSealUpload(file){
      // 图片文件转base64
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        // 获取到图片的base64编码
        this.sealImgBase64 = e.target.result;
        this.cropper ? this.cropper.replace(e.target.result) : this.cropperInit()
      }
      return false;
    },
    /**
     * 初始化裁剪器的方法。
     * @method cropperInit
     * @description 该方法用于初始化图片裁剪器，设置裁剪框的各种属性，并处理裁剪事件。
     * @param {Object} _this - Vue 实例的上下文。
     * @property {Object} $refs.sealCreateRef - Vue 组件中的 ref 引用，指向裁剪器容器元素。
     * @property {Object} cropper - 裁剪器实例对象，用于控制裁剪框的行为。
     * @property {Function} ready - 裁剪器准备就绪时的回调函数，用于手动设置裁剪框位置。
     * @property {Function} crop - 图片裁剪事件的处理函数，用于获取裁剪后的图片并转换为 base64 编码。
     */
    cropperInit(){
      const _this =this
      this.$nextTick(()=>{
        _this.cropper = new Cropper(_this.$refs.sealCreateRef, {
          // aspectRatio: 1, // 设置裁剪框的宽高比
          viewMode: 1,    // 允许拖动图片
          dragMode: 'move', // 仅允许移动图片
          autoCropArea: 1, // 定义裁剪区域占图片的大小(百分比)。取值为 0 - 1。
          cropBoxMovable: false, // 是否允许通过拖动来移动裁剪框
          cropBoxResizable: false, // 禁止调整裁剪框大小
          background: true, // 是否显示容器的背景
          centered: true, // 裁剪框居中
          movable:true, // 是否可以移动图片
          guides:false, // 是否显示裁剪框上的虚线
          ready() {
            // 由于 cropBoxMovable 和 cropBoxResizable 被禁用，我们需要手动设置裁剪框位置
            _this.changeSize()
          },
          /**
           * 处理图片裁剪事件的函数。
           * @param {Object} event - 图片裁剪事件对象。
           * @description 当用户进行图片裁剪操作时，此函数会被触发，并打印出事件对象以供调试。
           */
          crop(event) {
            // console.log('crop:::event',event);
            _this.debounce(_this.getImgView,500)
            // console.log('event',event);
            // _this.getImgView()
          },
        });
      })
    },
    getImgView(){
      const _this = this;
      let loadingInstance = Loading.service({
        target: _this.$refs.previewRef,
      });
      const croppedCanvas = _this.cropper.getCroppedCanvas({width: this.convertWidth, height: this.convertHeight});
      const base64Image = croppedCanvas.toDataURL('image/png',1.0); // 1.0表示质量等级，范围为0到1，1表示最高质量
      // this.cropedImg = base64Image;
      _this.previewSign({imgBase64:base64Image}).finally(()=>{loadingInstance.close();})
    },
    // 防抖处理
    debounce(func, wait) {
      const _this= this;
      clearTimeout(_this.antiShakeTimer);
      _this.antiShakeTimer = setTimeout(()=>{
        func()
      },wait)
    },
    handleResize() {
      // 当窗口大小改变时，重新计算响应式值。
      // 由于计算属性是基于依赖的，所以这里不需要手动触发计算属性。Vue会自动处理。
      // this.responsiveValue; // 触发getter以重新计算值（虽然实际上不需要这样做，因为Vue会处理）
    }
  },
  mounted() {
    let loadingInstance = Loading.service({
        target: this.$refs.previewRef,
      });
      setTimeout(() => {loadingInstance.close()}, 1000);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function () {
    this.cropper && this.cropper.destroy();
    this.antiShakeTimer && clearTimeout(this.antiShakeTimer);
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>

<style lang='less' scoped>
@import url('../../assets/style/cssVariable.less'); //引入公共css类
@distance:10px;
@distance20:20px;
.row-box {
  font-size:0.7vw;
  max-height: 90vh;
  .m-b-10{
    margin-bottom: @distance;
  }
  .m-t-distance{
    margin-top: @distance20;
  }
  .first{
    padding: 0 @distance20;
    .first-content{
      .seal-creat{
        height: 35vh;
        border: 1px dashed @ebq-grey-black2;
        .seal-canvas-sty{
          border: 1px solid @ebq-blue;
        }
          >p{
            font-size: 1vw;
            margin-top: 2vh;
          }
          .icon-sty{
            font-size: 4vw;
            font-weight: bolder;
          }
      }
      .option{
        height: 10vh;
        padding: @distance20;
        background-color: @ebq-grey-white8;
        .option-tool{
            >i {
              font-size: 1vw;
              cursor: pointer;
            }
            >i:hover{
                color:@ebq-blue;
              }
          .re-upload{
            color:@ebq-blue;
            cursor: pointer;
          }
        }
      }
    }
  }
  .second{
    border-left: 1px solid @ebq-grey-black2;
    border-right: 1px solid @ebq-grey-black2;
    .second-body{
      padding: 0 @distance20;
      .refresh{
        float: right;
        color:@ebq-blue;
        cursor: pointer;
      }
      .color-radio{
        /deep/ .el-radio__input{
          display: none;
        }
        /deep/ .el-radio{
          margin-right: 5px;
        }
      }
    }
  }
  .third{
    padding: 0 @distance20;
    .prview-img{
      width: 100%;
      height: 15vw;
      display: flex;
      align-items: center;
      justify-content: center;
      // border: 1px solid @ebq-grey-black2;
      margin-bottom: 10px;

      >img{
        border: 1px solid @ebq-gray;
      }
    }
    .confirm-btn{
      margin-top: @distance20;
      width: 100%;
    }
  }
  .pub-sty{
    height: 60vh;
    padding: 5px;
  }
}
.color-item-sty{
  width: 3.4vw;
  height: 26px;
  padding: 2px;
  border-radius: 2px;
  position: relative;
  border: 1px solid transparent;
}
.select-sty{
  border: 1px solid @ebq-red !important;
}
.select-sty::after{
  content: "";
  display: inline-block;
  width: 10px;
  height: 5px;
  position: absolute;
  border-left: 2px solid @ebq-white;
  border-bottom: 2px solid @ebq-white;
  transform: rotate(-45deg);
  top: 7px;
  left: 1.4vw;
}
.select-none-sty{
  border: 1px solid @ebq-red !important;
}
.select-none-sty::after{
  content: "";
  display: inline-block;
  width: 10px;
  height: 5px;
  position: absolute;
  border-left: 2px solid @ebq-white;
  border-bottom: 2px solid @ebq-white;
  transform: rotate(-45deg);
  top: 7px;
  left: 1.4vw;
  border-color: #000;
}
.seal-dome-none {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  cursor: pointer;
  border: 2px solid @ebq-gray-white;
  position: relative;
  .none-sty{
    display: inline-block;
    width: 100%;
    height: 2px;
    background-color: @ebq-gray-white;
    position: absolute;
    top: 39%;
    left: 0px;
    transform: rotate(16deg);
  }
}
.seal-dome {
  // width: 58px;
  // height: 26px;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  cursor: pointer;
}
.blue {
background-color: rgb(0,0,245);
}
.red {
background-color: rgb(234,51,35);
}
.black{
background-color: rgb(0,0,0);
}
.text-color{
color: @ebq-grey;
}
.tips{
display: flex;
align-items: center;
justify-content: space-between;
margin-top: 10px;
>div{
  &:first-child{
    width: 80px;
    height: 80px;
    margin-right: 10px;
    border: 1px solid @ebq-grey-black2;
    >img{
      width: 100%;
    }
  }
  &:last-child{
    flex: 1;
    p{
      margin-bottom: 5px;
    }
  }
}
}
.flex-col-center{
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
}
.flex-between{
display: flex;
align-items: center;
justify-content: space-between;
}
.flex-around{
display: flex;
align-items: center;
justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// components/tpl-editor/localSeal.vue